var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBonhommeFolks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1234.72 776.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke: #ff4438;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-width: 13.95px;\n      }\n\n      .cls-4 {\n        fill: #ff4438;\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-6 {\n        fill: #1d1d1b;\n      }\n\n      .cls-3 {\n        stroke: #1d1d1b;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 1234.72,
    height: 776.45
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 1234.72,
    height: 776.45
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 1234.72,
    height: 776.45
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M755.96,514.81c20.06,13.71,37.48,42.7,41.97,64.67,3.97,19.41,2.06,38.13-6.56,55.79-5.42,12.83-20.9,43.98-21.48,47.88-.55,3.68,1.5,6.08,5.47,7.06,11.33,2.8,22.68,5.54,33.93,8.59,14.23,3.85,28.45,7.98,40.46,16.47,13.1,9.25,15.64,19.38,4.56,34.45-9.6,13.05-24.19,18.88-40.21,19.56-20.03.85-39.83-.8-58.25-10.37-18.42-9.57-27.54-23.41-26.7-42.9.22-5.08-.78-7.9-6.72-9.35-7.6-1.86-14.89-4.93-22.19-7.74-3.36-1.29-6.86-2.76-9.58-4.94-9.02-7.2-9.74-16.48-2.49-26.63,1.43-2.01,3.12-3.86,5.44-7.22,11.54-11.64,24.45-22.22,37.08-40.48,4.89-7.45,9.87-20.19,6.26-36.08-5.2-19.26-15.45-37.6-32.33-46.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M755.96,514.81c20.06,13.71,37.48,42.7,41.97,64.67,3.97,19.41,2.06,38.13-6.56,55.79-5.42,12.83-20.9,43.98-21.48,47.88-.55,3.68,1.5,6.08,5.47,7.06,11.33,2.8,22.68,5.54,33.93,8.59,14.23,3.85,28.45,7.98,40.46,16.47,13.1,9.25,15.64,19.38,4.56,34.45-9.6,13.05-24.19,18.88-40.21,19.56-20.03.85-39.83-.8-58.25-10.37-18.42-9.57-27.54-23.41-26.7-42.9.22-5.08-.78-7.9-6.72-9.35-7.6-1.86-14.89-4.93-22.19-7.74-3.36-1.29-6.86-2.76-9.58-4.94-9.02-7.2-9.74-16.48-2.49-26.63,1.43-2.01,3.12-3.86,5.44-7.22,11.54-11.64,24.45-22.22,37.08-40.48,4.89-7.45,9.87-20.19,6.26-36.08-5.2-19.26-15.45-37.6-32.33-46.07"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M619.79,571.58c184.92,0,334.83-123.79,334.83-276.49S804.71,18.6,619.79,18.6s-334.83,123.79-334.83,276.49,149.91,276.49,334.83,276.49"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 619.79,
    cy: 295.09,
    rx: 334.83,
    ry: 276.49
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M626.4,295.11c3.82,0,6.91-3.06,6.91-6.83s-3.09-6.83-6.91-6.83-6.91,3.06-6.91,6.83,3.09,6.83,6.91,6.83"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 626.4,
    cy: 288.27,
    rx: 6.91,
    ry: 6.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M877.17,153.28s13.23-124.31,152.09-124.31,201.35,89.66,198.38,170.11c-3.19,86.34-43.05,145.35-68.61,181.01-22.7,31.67-44.79,56.71-82.94,69.79-26.66,9.14-42.42,69.79-53.44,87.24-11.02,17.45-32.89,42.44-70.54,39.05-37.55-3.38-71.37-31.94-70.09-86.59,1.09-46.69,3.23-60.3,3.23-60.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M877.17,153.28s13.23-124.31,152.09-124.31,201.35,89.66,198.38,170.11c-3.19,86.34-43.05,145.35-68.61,181.01-22.7,31.67-44.79,56.71-82.94,69.79-26.66,9.14-42.42,69.79-53.44,87.24-11.02,17.45-32.89,42.44-70.54,39.05-37.55-3.38-71.37-31.94-70.09-86.59,1.09-46.69,3.23-60.3,3.23-60.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M969.27,247.43s-48.5-37.08-24.25-104.69c24.25-67.61,115.66-53.08,154.33-43.62,36.99,9.05,83.78,56.71,83.78,102.51s-11.02,109.05-77.16,178.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M941.35,157.27s95.59-21.19,136.38,27.43c32.13,38.29,17.59,87.09-9.19,121.36-15.21,19.46-52.54,64.88-52.54,113.66s-48.19,45.36-59.94,43.62c-11.23-1.66-26.8-11.93-25.17-37.44,1.24-19.38,22.05-28.59,22.05-28.59,0,0,35.17-7.48,34.75-28.31-.63-31.22-33.85-22.72-36.76-43.08-1.43-10-.54-35.63-.54-35.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M357.55,153.28s-13.23-124.31-152.09-124.31S4.11,118.63,7.08,199.07c3.19,86.34,43.05,145.35,68.61,181.01,22.7,31.67,44.79,56.71,82.94,69.79,26.66,9.14,42.42,69.79,53.44,87.24,11.02,17.45,32.89,42.44,70.54,39.05,37.55-3.38,74.86-31.94,73.58-86.59-1.09-46.69-6.72-60.3-6.72-60.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M357.55,153.28s-13.23-124.31-152.09-124.31S4.11,118.63,7.08,199.07c3.19,86.34,43.05,145.35,68.61,181.01,22.7,31.67,44.79,56.71,82.94,69.79,26.66,9.14,42.42,69.79,53.44,87.24,11.02,17.45,32.89,42.44,70.54,39.05,37.55-3.38,74.86-31.94,73.58-86.59-1.09-46.69-6.72-60.3-6.72-60.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M265.46,247.43s48.5-37.08,24.25-104.69c-24.25-67.61-115.66-53.08-154.33-43.62-36.99,9.05-83.78,56.71-83.78,102.51s11.02,109.05,77.16,178.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M293.38,157.27s-95.59-21.19-136.38,27.43c-32.13,38.29-17.59,87.09,9.19,121.36,15.21,19.46,52.54,64.88,52.54,113.66s48.19,45.36,59.94,43.62c11.23-1.66,26.8-11.93,25.17-37.44-1.24-19.38-22.05-28.59-22.05-28.59,0,0-35.17-7.48-34.75-28.31.63-31.22,33.85-22.72,36.76-43.08,1.43-10,.54-35.63.54-35.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M544.4,547.03c-3.96,22.95-16.7,56.96-48.86,82.23-16.7,12.13-35.41,19.05-56.15,19.89-14.69,1.31-51.41,2.57-55.39,3.85-3.76,1.21-5.11,4.01-4.25,7.77,2.47,10.72,5.01,21.43,7.22,32.2,2.79,13.62,5.3,27.35,2.67,41.22-2.88,15.13-11.38,21.85-30.77,19.46-16.8-2.07-28.97-11.58-36.89-24.63-9.9-16.31-17.31-33.58-16.56-53.28.76-19.71,9.81-33.6,28.77-41.76,4.95-2.13,7.18-4.24,5.86-9.85-1.68-7.18-2.06-14.65-2.69-22.02-.29-3.39-.48-6.97.36-10.23,2.76-10.79,11.29-15.61,24.25-14.18,2.56.28,5.09.85,9.35,1.25,16.33,4.33,32.27,10.29,55.42,12.52,9.32.69,23.73-.95,37.24-11.18,9.54-7.81,28.81-29.2,29.24-47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M544.4,547.03c-3.96,22.95-16.7,56.96-48.86,82.23-16.7,12.13-35.41,19.05-56.15,19.89-14.69,1.31-51.41,2.57-55.39,3.85-3.76,1.21-5.11,4.01-4.25,7.77,2.47,10.72,5.01,21.43,7.22,32.2,2.79,13.62,5.3,27.35,2.67,41.22-2.88,15.13-11.38,21.85-30.77,19.46-16.8-2.07-28.97-11.58-36.89-24.63-9.9-16.31-17.31-33.58-16.56-53.28.76-19.71,9.81-33.6,28.77-41.76,4.95-2.13,7.18-4.24,5.86-9.85-1.68-7.18-2.06-14.65-2.69-22.02-.29-3.39-.48-6.97.36-10.23,2.76-10.79,11.29-15.61,24.25-14.18,2.56.28,5.09.85,9.35,1.25,16.33,4.33,32.27,10.29,55.42,12.52,9.32.69,23.73-.95,37.24-11.18,9.54-7.81,28.81-29.2,29.24-47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M321.24,300.6c0,162.16,132.22,293.62,295.33,293.62s295.34-131.46,295.34-293.62S779.69,6.98,616.57,6.98s-295.33,131.46-295.33,293.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M321.24,300.6c0,162.16,132.22,293.62,295.33,293.62s295.34-131.46,295.34-293.62S779.69,6.98,616.57,6.98s-295.33,131.46-295.33,293.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M388.47,300.6c0,142.55,112.11,258.11,250.39,258.11s250.4-115.56,250.4-258.11S777.15,42.49,638.86,42.49s-250.39,115.56-250.39,258.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M462.52,300.6c0,110.47,90.5,200.02,202.15,200.02s202.14-89.55,202.14-200.02-90.5-200.02-202.14-200.02-202.15,89.55-202.15,200.02Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 699.87,
    cy: 300.6,
    rx: 145.13,
    ry: 143.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M650.08,300.6c0,46.83,38.39,84.8,85.73,84.8s85.74-37.97,85.74-84.8-38.38-84.8-85.74-84.8-85.73,37.97-85.73,84.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M684.22,320.77c14.17,0,25.66-11.49,25.66-25.66s-11.49-25.66-25.66-25.66-25.66,11.49-25.66,25.66,11.49,25.66,25.66,25.66"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonhommeFolks);
export default __webpack_public_path__ + "static/media/bonhomme-folks.d485392d014af7ebb438199886b8fa2c.svg";
export { ForwardRef as ReactComponent };